import { CancelTwoTone, CloseTwoTone, SaveTwoTone } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  IconButton,
  Popover,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { createNertzGame } from "../../api/NertzApi";

function NertzEditor({ open, onClose, ...others }) {
  const [playTo, setPlayTo] = useState(150),
    [isBusy, setIsBusy] = useState(false),
    handleClose = () => {
      onClose && onClose({}, "escapeKeyDown");
    };

  return (
    <Popover {...others} onClose={onClose} open={open}>
      <Card>
        <CardHeader
          action={
            <IconButton onClick={handleClose}>
              <CloseTwoTone />
            </IconButton>
          }
          title="Create a Nertz Game"
        />
        <CardContent>
          <TextField
            fullWidth
            InputProps={{
              step: 1,
            }}
            label="Play to"
            onChange={(e) => {
              setPlayTo(parseInt(e.target.value));
            }}
            required
            type="number"
            value={playTo}
          />
        </CardContent>
        <CardActions>
          <Button
            disabled={isBusy}
            startIcon={<SaveTwoTone />}
            variant="contained"
            onClick={() => {
              setIsBusy(true);

              createNertzGame({
                playTo: playTo,
              }).finally(() => {
                setIsBusy(false);
                handleClose();
              });
            }}
          >
            Save
          </Button>
          <Button
            onClick={handleClose}
            startIcon={<CancelTwoTone />}
            variant="outlined"
          >
            Cancel
          </Button>
        </CardActions>
      </Card>
    </Popover>
  );
}

export default NertzEditor;
